function TableView1({ calculationResult }) {
  // Helper function to format values - show N/A for negative values
  const formatValue = (value) => {
    if (value < 0) {
      return "N/A";
    }
    return value;
  };

  return (
    <div className="results-section">
      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">Option 1</span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">
            OUTRIGHT PRICE WITH IMMEDIATE PAYMENT
          </span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-2">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}></div>

      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">
            OPTION 2 - ORD - REGUALR 15% - 85%
          </span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">ORD - REGULAR</span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            15% ON AGREEMENT AND BALANCE 85% 12 MONTH
          </span>
        </div>
        <div className="result-item row4-col1">
          <span className="result-label">
            APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF SALE
          </span>
        </div>
        <div className="result-item row5-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-4">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">
            OPTION 3 - ORD - REGUALR 10% - 90%
          </span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">ORD - REGULAR - 12 MONTHS</span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            10% ON AGREEMENT AND BALANCE 90% ON 12TH MONTH
          </span>
        </div>
        <div className="result-item row4-col1">
          <span className="result-label">
            APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF SALE
          </span>
        </div>
        <div className="result-item row5-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-4">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">
            OPTION 4 - ORD - REGUALR 5% - 95%
          </span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">ORD - REGULAR</span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            5% ON AGREEMENT AND BALANCE 95% ON 12TH MONTH
          </span>
        </div>
        <div className="result-item row4-col1">
          <span className="result-label">
            APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF SALE
          </span>
        </div>
        <div className="result-item row5-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-4">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">
            OPTION 5 - ORD - 24 10% - 10% - 80%
          </span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">ORD - 24</span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            10% ON AGREEMENT AND 10% ON APPROVAL (IN 12 MONTHS) AND BALANCE 80%
            ON 24TH MONTH
          </span>
        </div>
        <div className="result-item row4-col1">
          <span className="result-label">
            APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF SALE
          </span>
        </div>
        <div className="result-item row5-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-4">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <div className="results-grid">
        {/* Row 1, Column 1 */}
        <div className="result-item row1-col1">
          <span className="result-label">
            OPTION 6 - ORD - 24 10% - 10% - 20% 20% 20% 20%
          </span>
        </div>

        {/* Row 1, Column 2 */}
        <div className="result-item row1-col2">
          <span className="result-label">Per aver in Cr</span>
        </div>

        {/* Row 2, Column 1 */}
        <div className="result-item row2-col1">
          <span className="result-label">ORD - 24</span>
        </div>

        {/* Row 3, Column 1 */}
        <div className="result-item row3-col1">
          <span className="result-label">
            10% ON AGREEMENT AND 10% ON APPROVAL (IN 12 MONTHS) AND 20% EVERY
            QUARTER FROM 15TH MONTH
          </span>
        </div>
        <div className="result-item row4-col1">
          <span className="result-label">
            APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF SALE
          </span>
        </div>
        <div className="result-item row5-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        <div className="result-item row6-col1">
          <span className="result-label">
            ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION
          </span>
        </div>

        {/* Row 2, Row 3, Column 2 (Merged Cells) */}
        <div className="result-item merged-cell-5">
          <span className="result-label">{formatValue(calculationResult.D10_value)}</span>
        </div>
      </div>

      <table class="table-view">
        <thead>
          <tr>
            <th className="table-head-font">OPTION 7 - JV</th>
            <th className="table-head-font">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>JV CG RATIO</td>
            <td>{}</td>
          </tr>

          <tr>
            <td>JV LO RATIO</td>
            <td>{}</td>
          </tr>

          <tr>
            <td>10% OF PROPERTY VALUE AS ADVANCE</td>
            <td>{}</td>
          </tr>

          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
            <td rowspan="4" class="merged-cell">
              {}
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
          <tr>
            <td>
              NO COMMITMENT ON APPROVAL TIMELINE. THIS IS CALENDAR COMMITMENT
            </td>
          </tr>
          <tr>
            <td>SHARING : NOT SHARING: FRC</td>
          </tr>
        </tbody>
      </table>

      <table class="table-view">
        <thead>
          <tr>
            <th className="table-head-font">OPTION 8 - DEVELOPMENT MODEL</th>
            <th className="table-head-font"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              LO TO INFUSE CAPITAL FOR APPROVALS & ANY INITIAL FUND GAP FOR
              CONSTRUCTION
            </td>
            <td rowspan="4" class="merged-cell">
              14% OF THE TOPLINE GIVEN TO CG
            </td>
          </tr>
          <tr>
            <td>CG ONLY CHARGES 14% OF THE TOTAL REVENUE</td>
          </tr>
          <tr>
            <td>
              ALL OTHER STAFF COST WHO ARE ATTRIBUTABLE TO PROJECTS (SALES,
              MKTG, ENGG ETC) WILL BE DEDICATEDLY BUILT TO PROJECT AS PART OF
              OPERATIVE COST
            </td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TableView1;